const BASE_URL = import.meta.env.VITE_BASE_URL;
const TIMESTAMP_ENDPOINT = import.meta.env.VITE_TIMESTAMP_ENDPOINT;
const TIMESTAMP_URL = `${BASE_URL}${TIMESTAMP_ENDPOINT}`;

export const API = {
  TIMESTAMP: {
    base: `${TIMESTAMP_URL}`,
    post: `${TIMESTAMP_URL}/post`, // POST
    status: `${TIMESTAMP_URL}/status`, // GET
    insert: `${TIMESTAMP_URL}/insert`, // POST
    patch: {
      fileLabel: (hash: string) => `${TIMESTAMP_URL}/${hash}/file-label`,
      status: (uid: string) => `${TIMESTAMP_URL}/${uid}/update-status`,
    },
    get: {
      proof: (hash: string) => `${TIMESTAMP_URL}/${hash}/proof`,
    },
    getByReqId: (reqId: string) => `${TIMESTAMP_URL}/req/${reqId}`, // GET
    getByUid: (uid: string) => `${TIMESTAMP_URL}/uid/${uid}`, // GET
    pagination: `${TIMESTAMP_URL}/pagination`, // GET
    search: `${TIMESTAMP_URL}/search`, // GET
    getAll: `${TIMESTAMP_URL}`,
    delete: (hash: string) => `${TIMESTAMP_URL}/${hash}`,
  },

  BLOCKCHAIN: {
    base: `${BASE_URL}/blockchain`,
    create: `${BASE_URL}/blockchain`, // POST
    getAll: `${BASE_URL}/blockchain`, // GET
    // getByHash: (hash: string) => `${BASE_URL}/blockchain/history/${hash}`,
    getByReqId: (reqId: string) => `${BASE_URL}/blockchain/${reqId}`,
    // update: (hash: string) => `${BASE_URL}/blockchain/${hash}`,
    delete: (reqId: string) => `${BASE_URL}/blockchain/${reqId}`,
  },

  HISTORY: {
    base: `${BASE_URL}/history`,
    create: `${BASE_URL}/history`, // POST
    getAll: `${BASE_URL}/history`, // GET
    getById: (id: string) => `${BASE_URL}/history/${id}`, // GET
    paginate: `${BASE_URL}/history/pagination`, // GET
    search: `${BASE_URL}/history/search`, // GET

    update: (id: string) => `${BASE_URL}/history/${id}`,
    patch: {
      validationComplete: (id: string) => `${BASE_URL}/history/${id}/validation-complete`,
      jsonTimestamp: (id: string) => `${BASE_URL}/history/${id}/json-timestamp`,
      fileLabel: (id: string) => `${BASE_URL}/history/${id}/file-label`,
      invalid: (id: string) => `${BASE_URL}/history/${id}/invalid`,
      token: (id: string) => `${BASE_URL}/history/${id}/token`,
      cancel: (id: string) => `${BASE_URL}/history/${id}/cancel`,
    },

    delete: (id: string) => `${BASE_URL}/history/${id}`,
  },
};

// HOW TO USE
// // Static
// axios.get(API.HISTORY.paginate);

// // Dynamic
// axios.patch(API.HISTORY.patch.cancel(hash), data);
// axios.get(API.BLOCKCHAIN.getByHash(hash));
// axios.delete(API.HISTORY.delete(hash));
